<template>
  <div>
    <div id="note-container">
      <div id="new-note-wrapper">
        <button
          id="show-notes-list-button"
          class="button-large"
          @click="showNotesList()"
        >
          Show Notes
        </button>

        <button
          id="new-note-button"
          class="button-large"
          @click="createNewNote()"
        >
          New Note
        </button>
      </div>

      <input id="note-title" v-model="note.title" placeholder="Title" />

      <input id="note-tags" v-model="note.tags" placeholder="Tags" />

      <textarea
        id="note-content"
        v-model="note.content"
        placeholder="Content"
      />

      <div id="note-actions">
        <button
          id="delete-button"
          class="button-large"
          @click="openConfirmationModal()"
        >
          Delete
        </button>

        <button id="save-button" class="button-large" @click="saveNote()">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import store from "../store";
import { defaultNote } from "../store";

export default {
  name: "App",
  components: {},

  setup() {
    let note = computed(function () {
      return store.state.activeNote;
    });

    return {
      note,
    };
  },

  methods: {
    showNotesList() {
      document.getElementById('notes-list').style.display = 'block';
      document.getElementById('note').style.display = 'none';
      document.getElementById('show-notes-list-button').style.display = 'none';
      document.getElementById("new-note-button").style.display = "none";
    },

    createNewNote() {
      console.log(defaultNote)
      store.commit("setActiveNote", { ...defaultNote });
    },

    saveNote() {
      this.$emit("save-note");
    },

    openConfirmationModal() {
      console.log("emitting: ", store.state.activeNote);
      this.$emit("open-confirmation-modal", store.state.activeNote);
    },
  },
};
</script>

<style>
#note-container {
  width: 90%;
  height: 100vh;

  margin: auto;
}

#new-note-wrapper {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}

#new-note-button {
  display: inline;
  margin-bottom: 1rem;
  background-color: hsl(174, 72%, 76%);
}

#show-notes-list-button {
  margin-bottom: 1rem;
  background-color: hsl(174, 72%, 76%);
  display: none;
}

#show-notes-list-button:hover {
  background-color: hsl(174, 72%, 56%);
}

#show-notes-list-button:active {
  background-color: hsl(174, 72%, 46%);
}

#new-note-button:hover {
  background-color: hsl(174, 72%, 56%);
}

#new-note-button:active {
  background-color: hsl(174, 72%, 46%);
}

#note-title {
  margin-bottom: 0.5rem;
}

#note-title:focus {
  outline: none;
}

#note-tags {
  margin-bottom: 2rem;
  font-size: x-small;
}

#note-tags:focus {
  outline: none;
}

#note-container #note-title {
  box-sizing: border-box;
  width: 100%;
}

#note-container #note-tags {
  box-sizing: border-box;
  width: 100%;
}

#note-container #note-content {
  box-sizing: border-box;
  height: 50%;
  width: 100%;
  background-color: hsl(174, 72%, 76%);
  border: 0px;
  border-radius: 10px;
  padding: 5px 5px;
}

#note-content {
  resize: none;
}

#note-content:focus {
  outline: none;
}

#note-actions {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;

  margin-top: 1rem;
}

#delete-button {
  background-color: hsl(174, 72%, 46%);
}

#delete-button:hover {
  background-color: hsl(174, 72%, 56%);
}

#delete-button:active {
  background-color: hsl(174, 72%, 76%);
}

#save-button {
  background-color: hsl(174, 72%, 76%);
}

#save-button:hover {
  background-color: hsl(174, 72%, 56%);
}

#save-button:active {
  background-color: hsl(174, 72%, 46%);
}

.inner-shadow {
  -moz-box-shadow: inset 0 0 10px hsl(174, 72%, 26%);
  -webkit-box-shadow: inset 0 0 10px hsl(174, 72%, 26%);
  box-shadow: inset 0 0 10px hsl(174, 72%, 26%);
}
</style>